import { PureComponent } from 'preact-compat'
import { resolveReply, resolveTopic } from '../services/topicService'
import { ContentType } from '@insided/shared/utils/contentType'
import Button from '@insided/control/uikit/Button'
import ResolveModal from './ResolveModal'
import { ReportedContent } from './Report'
import { sendPrivateMessage } from '@insided/control/modules/ContentModeration/TopicModeration/services/privateMessageService'
/* eslint-disable import/no-internal-modules */
import { fetchPhrase } from '@insided/deprecated-libs/translationsUtils/phrase'

export interface ResolveProps {
  reportedContent: ReportedContent[]
  contentType: ContentType
  topicId?: number
  replyId?: number
  onResolve?: () => void
  onShowAlert?: (type: 'success' | 'error', message?: string) => void
  topicTitle: string
}

interface ResolveState {
  showResolveModal: boolean
}

class Resolve extends PureComponent<ResolveProps, ResolveState> {
  constructor(props: ResolveProps) {
    super(props)
    this.resolve = this.resolve.bind(this)
    this.state = {
      showResolveModal: false
    }
  }

  async componentDidMount() {
    await new Promise((resolve) => fetchPhrase('Control', 'topic_moderation.reported_content.resolve.private_message', (phrase) => resolve(phrase)))
  }

  showResolveModal(show: boolean) {
    this.setState({ showResolveModal: show })
  }

  async resolve(usernames: string[], message: string) {
    const { contentType, topicId, replyId, onResolve, onShowAlert } = this.props

    try {
      if (replyId) {
        await resolveReply(contentType, replyId)
      } else if (topicId) {
        await resolveTopic(contentType, topicId)
      }

      if (usernames.length > 0) {
        await sendPrivateMessage(usernames, message)
      }

      // refresh the page if content got resolved from the old topic moderation page
      if (!onResolve) {
        window.location.reload()
      }

      onResolve?.()
      onShowAlert?.('success', 'Report(s) has been resolved.')
    } catch {
      onShowAlert?.('error')
    }
  }

  render() {
    const { showResolveModal } = this.state
    const { reportedContent, topicTitle } = this.props
    return (
      <div>
        <Button title='Resolve' variant='success' onClick={() => this.showResolveModal(true)} data-qa='qa-resolve' />
        {showResolveModal && (
          <ResolveModal
            reportedContent={reportedContent}
            onResolve={this.resolve}
            onClose={() => this.showResolveModal(false)}
            topicTitle={topicTitle}
          />
        )}
      </div>
    )
  }
}

export default Resolve
